import React from "react";
import { useTranslation } from "react-i18next";
import { useMandatorContext } from "@bn/theming";
import { SidebarMenu, MenuItem, MenuItemExpandable } from "@components";
import { MenuGroup } from "../SidebarMenu/MenuGroup";
import { usePathOrRouteMatcher } from "../../../../../hooks/usePathMatcher";
import { sidebarIcons } from "./icons";
import {
  DEPOTS_ACCOUNTS_ROUTES,
  INVESTMENTS_SELECTED_ROUTES,
} from "./constants";

export interface AppSidebarMenuProps {
  className?: string;
  collapsed?: boolean;
}

export const AppSidebarMenu = ({
  className,
  collapsed = false,
}: AppSidebarMenuProps) => {
  const { t } = useTranslation();
  const { matchesPath, matchesRoutes } = usePathOrRouteMatcher();
  const { isAriva } = useMandatorContext();

  const isInvestmentSelected = matchesRoutes(INVESTMENTS_SELECTED_ROUTES);
  const isDepotsAccountsSelected = matchesRoutes(DEPOTS_ACCOUNTS_ROUTES);
  const isNewsSelected = matchesPath("/news");
  const isCommunitySelected = matchesPath("/community");

  return (
    <SidebarMenu className={className} collapsed={collapsed}>
      <MenuGroup>
        <MenuItem
          to="/"
          name={t("appSidebar.menu.home")}
          before={sidebarIcons[matchesPath("/") ? "homeSelected" : "home"]}
          selected={matchesPath("/")}
        />
        <MenuItemExpandable
          to="/investments"
          name={t("appSidebar.menu.investments")}
          before={
            sidebarIcons[
              isInvestmentSelected ? "investmentsSelected" : "investments"
            ]
          }
          selected={isInvestmentSelected}
        >
          <MenuItem
            selected={matchesPath("/investments")}
            to="/investments"
            name={t("appSidebar.menu.portfolio")}
          />
          <MenuItem
            selected={matchesPath("/classifications")}
            to="/classifications"
            name={t("appSidebar.menu.classification")}
          />
          <MenuItem
            selected={matchesPath("/dividend-planner")}
            to="/dividend-planner"
            name={t("appSidebar.menu.dividendPlanner")}
          />
        </MenuItemExpandable>

        {isAriva && (
          <>
            <MenuItem
              to="/news"
              name={t("appSidebar.menu.news")}
              before={sidebarIcons[isNewsSelected ? "newsSelected" : "news"]}
              selected={isNewsSelected}
            />
            <MenuItem
              to="/community"
              name={t("appSidebar.menu.community")}
              before={
                sidebarIcons[
                  isCommunitySelected ? "communitySelected" : "community"
                ]
              }
              selected={isCommunitySelected}
            />
          </>
        )}

        <MenuItem
          to="/depots-accounts"
          name={t("appSidebar.menu.depotsAndAccounts")}
          before={
            sidebarIcons[
              isDepotsAccountsSelected ? "accountsSelected" : "accounts"
            ]
          }
          selected={isDepotsAccountsSelected}
        />
      </MenuGroup>
    </SidebarMenu>
  );
};
